<template>
  <a
    v-if="isReload"
    @click="reload"
    data-tooltip="Clique para recarregar a página"
    class="c-base-reload tooltip is-multiline"
    href="#"
  >
    <base-icon name="painel/reload-icon" class="c-base-reload__icon" />
    <span class="c-base-reload__label">{{ label }}</span>
  </a>
  <div v-else class="c-base-reload">
    <a
      :class="{ 'is-secondary': dark }"
      class="c-base-reload__loading button is-loading is-large"
    >
      Carregando
    </a>
    <p v-if="label">{{ label }}</p>
  </div>
</template>

<script>
export default {
  props: {
    isReload: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: 'Recarregar',
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    reload() {
      window.location.reload(true)
    },
  },
}
</script>

<style lang="scss">
.c-base-reload {
  display: inline-block;
  margin-top: 6px;
  text-align: center;

  &__icon {
    display: block;
    margin: 0 auto;
    width: 24px;
    height: 24px;
  }

  &__label {
    display: block;
    font-size: 10px;
  }

  &__loading {
    border-color: transparent !important;
    background-color: transparent !important;
  }
}
</style>
